import styles from './styles.less';
import { observer } from 'mobx-react';


const ShowsList = (props) => (
    <nav className={ cx(styles.root, props.className) }>
        <ul className={ styles.list }>
            { props.shows.length <= 0 &&
            <li className={ styles.show }>
                <span className={ styles.notFound }>No Shows Found.</span>
            </li> }
            { props.shows.map(show => (
            <li className={ styles.show }>
                <a
                    className={ styles.showLink }
                    href={ show.url }>
                    { show.title }
                </a>
            </li>
            )) }
        </ul>
    </nav>
);

ShowsList.propTypes = {
    shows: React.PropTypes.array.isRequired
};


export default observer(ShowsList);



// WEBPACK FOOTER //
// ./src/show-index/components/show-list/index.js